import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'gk-common-bootstrap-form-field',
  imports: [CommonModule, FormlyModule],
  template: `
    <div [ngClass]="to['wrapperClass']">
      <label *ngIf="to.label" [for]="id" [ngClass]="to['labelClass']">
        {{ to.label }}
      </label>
      <ng-template #fieldComponent></ng-template>
      <div *ngIf="showError">
        <div class="alert alert-danger mt-2" tabindex="0">
          <formly-validation-message
            [field]="field"
          ></formly-validation-message>
        </div>
      </div>
    </div>
  `,
})
export class GkCommonBootstrapFormFieldComponent extends FieldWrapper {}
